/** @format */

import angular from 'angular';
import { GalabidUrlModule } from 'crowdcomms-js/lib/galabid/galabid-url';

import { GbRootController } from './gb-root.controller.js';

export const ControllersModule = angular
    .module('galabid-presenter.shared.controllers', [GalabidUrlModule])
    .controller('GbRootController', GbRootController).name;
